export const loginBranding = {
  title: "ITEMA",
  heading: "Join the ITEMA Workspace",
  description:
    "Built for educators across schools, tutoring environments, and independent teaching experiences.",
  features: [
    {
      id: "resources",
      title: "Centralized Resources",
      description:
        "Keep your lesson plans and materials in one empathetic space.",
    },
    {
      id: "insights",
      title: "Student Insights",
      description:
        "Focus on progress with tools designed for educator clarity.",
    },
  ],
};

export const loginFormCopy = {
  title: "Login to your account",
  accountPrompt: "Don't have an account?",
  createAccountLink: "Create one",
  emailLabel: "Professional Email",
  emailPlaceholder: "jane.doe@school.edu",
  passwordLabel: "Password",
  passwordPlaceholder: "Enter your password",
  forgotPassword: "Forgot password?",
  submitLabel: "Login",
  submittingLabel: "Logging in…",
  orContinueWith: "Or continue with",
  createAccount: "Create Account",
  footerPrefix: "By signing in, you agree to our",
  termsLabel: "Terms of Service",
  privacyLabel: "Privacy Policy",
};

export { authTheme as loginTheme } from "./authTheme";
